import { AxiosInstance } from 'axios';
import { AccountInfo } from '@azure/msal-browser';

/**
 * Narrow type for the custom claims we read from idTokenClaims.
 * Extend as new claims are consumed in the UI.
 */
export interface HubIdTokenClaims {
    upn?: string | string[];
    name?: string;
    roles?: string[];
    [key: string]: unknown;
}

export const hasAccountInfo = (
    user: AccountInfo | undefined | null
): boolean => {
    return !!user;
};

/**
 * Checks whether the current URL contains OIDC redirect parameters
 * (used by MSAL auth code flow). Used to filter these from the recent pages list.
 */
export const isRedirectUrl = (location: Location): boolean => {
    const searchParams = new URLSearchParams(location.search);
    const hashParams = new URLSearchParams(location.hash.replace('#', '?'));

    return Boolean(
        searchParams.get('code') ||
            searchParams.get('id_token') ||
            searchParams.get('session_state') ||
            hashParams.get('code') ||
            hashParams.get('id_token') ||
            hashParams.get('session_state')
    );
};

export const setAxiosHeader = (axios: AxiosInstance, token: string) => {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

// User profile may include multiple UPNs if multiple IDPs have been used to sign in
export const getUpn = (
    user: AccountInfo | undefined,
    domain: string = 'microsoft.com'
): string | undefined => {
    const upnClaim: string | string[] | undefined =
        (user?.idTokenClaims as HubIdTokenClaims)?.upn ?? user?.username;
    if (upnClaim instanceof Array) {
        return upnClaim.find((u) => u.endsWith(domain));
    } else if (upnClaim?.endsWith(domain)) {
        return upnClaim;
    }
};
